import { Opts } from 'helpers/AdapterPlainDateTimeTemporal'

export const temporalEnLocale: Opts['locale'] = {
  code: 'en-US',
  weekStartsOn: 0
}

export const temporalFrLocale: Opts['locale'] = {
  code: 'fr-FR',
  weekStartsOn: 1
}

export const temporalNlLocale: Opts['locale'] = {
  code: 'nl-NL',
  weekStartsOn: 1
}

export const temporalEsLocale: Opts['locale'] = {
  code: 'es-ES',
  weekStartsOn: 1
}
